/**
 * Version tracking utilities for LinCal app updates
 */

import { VERSION_KEY } from './constants';

/**
 * Get the last seen version from LocalStorage
 * @returns {string|null} Last seen version or null if not set
 */
export function getLastSeenVersion() {
  try {
    return localStorage.getItem(VERSION_KEY);
  } catch (error) {
    console.error('Error reading last seen version:', error);
    return null;
  }
}

/**
 * Set the last seen version in LocalStorage
 * @param {string} version - Version string to store
 */
export function setLastSeenVersion(version) {
  try {
    localStorage.setItem(VERSION_KEY, version);
  } catch (error) {
    console.error('Error saving last seen version:', error);
  }
}
